import React, { useEffect, useState } from 'react';
import { IconButton } from 'rsuite';
import { IconGeneric } from '@/widgets/components/icon';
import styled from 'styled-components';

const StyledIcon = styled(IconGeneric)`
  color: ${(props) => props.color};
`;

const StyledRsIconButton = styled(IconButton)`
  &.rs-btn.rs-btn-icon {
    padding: ${(props) => props.padding};
  }
`;

export function StyledIconButton(props) {
  const [desiredIcons, setDesiredIcons] = useState(null);
  const { color, size, icon, text, onClick } = props;

  useEffect(() => {
    async function grabIcon() {
      const icons = await import('./export-icons');
      setDesiredIcons(icons);
    }
    grabIcon();
  }, []);

  return (
    desiredIcons && (
      <StyledRsIconButton
        padding={props.padding || '6px 7px 0px 8px'}
        circle={props.circle}
        icon={
          <StyledIcon
            color={color}
            size={size}
            icon={desiredIcons.icons[icon]}
          />
        }
        appearance={'subtle' || props.appearance}
        onClick={onClick}
      >
        {text}
      </StyledRsIconButton>
    )
  );
}
